import type { Action } from '~/composables/useRenderButtonPresets'

type ActionFunction<T> = (row: T) => Action[]
type ActionArrayOrFunction<T> = Action[] | ActionFunction<T>

function returnFunctionOrSelf<T>(actions: ActionArrayOrFunction<T>) {
  if (Array.isArray(actions)) {
    return () => actions
  }
  return actions
}

export default function<T>(actions?: ActionArrayOrFunction<T> | 'false', defaultActions?: ActionArrayOrFunction<T>) {
  if (actions === 'false') {
    return undefined
  }
  if (actions) {
    return returnFunctionOrSelf(actions)
  }
  return defaultActions ? returnFunctionOrSelf(defaultActions) : undefined
}
